import { useCallback, useEffect, useState } from 'react';
import { Subject } from 'rxjs';
export function useObservable(obs$, initialValue) {
    var _a = useState(initialValue), state = _a[0], setState = _a[1];
    useEffect(function () {
        var subscription = obs$.subscribe(function (val) { return setState(val); });
        return function () { return subscription.unsubscribe(); };
    }, [obs$]);
    return state;
}
export function useSubject() {
    var subject$ = useState(function () { return new Subject(); })[0];
    var next = useCallback(function (val) { return subject$.next(val); }, [subject$]);
    return [subject$, next];
}
//# sourceMappingURL=react.utils.js.map